import React, { FC, useState, useRef, useEffect } from 'react';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import { Container, ButtonSubmit, FormRow } from './styles';
import NewPassInput, { ValidationObj } from 'components/NewPassInput';
import ValidationInfo from './Validationinfo';
import {ReactComponent as showPassword} from 'assets/img/show-password-icon.svg';
import {ReactComponent as hidePassword} from 'assets/img/hide-password-icon.svg';
import { brokenRule } from 'utils/check-password';
interface ChangePassFrmProps {
  onSubmit: any;
}

interface ChangePassFrmType {
  pass: string;
  newPass: string;
  confirmPass: string;
}

const ChangePassFrm: FC<ChangePassFrmProps> = ({ onSubmit }) => {

  const [formData, setFormData] = useState<ChangePassFrmType>({
    pass: '',
    newPass: '',
    confirmPass: '',
  });
  const [validation, setValidation] = useState<ValidationObj>({});
  const formRef = useRef(null);

  const onInputChange = (e, inputName) => {
    const newFormData: ChangePassFrmType = {...formData};
    newFormData[inputName] = e.target.value;
    setFormData(newFormData);
  };

  const [isSame, setIsSame] = useState<boolean>();

  useEffect(() => {
    setIsSame(formData.newPass === formData.confirmPass);
  }, [formData.newPass, formData.confirmPass])

  const onValidate = (e) => {
    e.preventDefault();
    const isInvalid = brokenRule(validation);
    if (isInvalid) return;
    onSubmit(formData, resetPasswordValidation);
  };

  const resetPasswordValidation = () => {
    resetInputs(formData, setFormData);
    setValidation({});
    setIsSame(true);
  }

  const resetInputs = (formData, setFormData) => {
    Object.keys(formData).forEach(field => {
      setFormData({
        [field]: ''
      })
    })
  }

  return (
    <Container>
      <Form ref={formRef} noValidate onSubmit={onValidate}>
        <FormRow>
          <Col xs={12} md={12}>
            <NewPassInput
              setValidation={setValidation}
              placeholder='Senha atual'
              name='pass'
              onInputChange={(e) => onInputChange(e, 'pass')}
              value={formData.pass}
              icons={{show: showPassword, hide: hidePassword}}
            />
          </Col>
        </FormRow>
        <FormRow>
          <Col xs={12} md={12}>
            <NewPassInput
              name='newPass'
              placeholder='Nova senha'
              onInputChange={onInputChange}
              setValidation={setValidation}
              value={formData.newPass}
              icons={{show: showPassword, hide: hidePassword}}
            />
          </Col>
        </FormRow>
        <FormRow>
          <Col xs={12} md={12}>
            <NewPassInput
              name='confirmPass'
              placeholder='Confirmar nova senha'
              isInvalidProp={!isSame}
              onInputChange={onInputChange}
              setValidation={setValidation}
              value={formData.confirmPass}
              icons={{show: showPassword, hide: hidePassword}}
            />
          </Col>
        </FormRow>
        <ButtonSubmit variant='primary' type='submit'>
          Enviar
        </ButtonSubmit>
      </Form>
      <ValidationInfo validation={validation} />
    </Container>
  );
};

export default ChangePassFrm;
